import './css/index.css';
import React from 'react';
import Select, { components } from 'react-select';
import { array, arrayOf, oneOfType, object, shape, string, func, bool } from 'prop-types';
import { COMPUTED_PUBLISHDATE } from '../../constants/search';

const Filter = ( props ) => {

    const { filter, labelId, value, isMulti, isMVP, isSVP, hasSingleFilter, customMaxHeight } = props;

    const facetOptions = filter.facets.map( ( facet ) => {

        const isArray = Array.isArray( facet );

        if ( isArray ) {

            return {
                label: facet[ 1 ],
                value: facet[ 0 ],
            };

        }
        else {

            const keyName = Object.keys( facet.query ).filter( key => facet.query[ key ] !== null )[ 0 ];

            return {
                label: facet.name,
                value: facet.query[ keyName ],
            };

        }

    } );

    const iconOption = ( { data, innerProps, isDisabled, isSelected } ) => {

        const optionSelectedClass = isSelected ? 'selected-option' : '';

        return isDisabled
            ? null
            : (
                <div data-content-type={ data.label.toLowerCase() } className={ `icon-dropdown ${ optionSelectedClass }` } { ...innerProps }>{ data.label }</div>
            );

    };

    const ValueContainer = ( { children, ...props } ) => {

        return (
            <components.ValueContainer { ...props }>

                <div className="custom-placeholder">{ filter.label }</div>

                { React.cloneElement( children[ 1 ] ) }

            </components.ValueContainer>
        );

    };

    ValueContainer.propTypes = {
        children: array,
    };

    const customOptions = () => {

        if ( isMulti || filter.name === COMPUTED_PUBLISHDATE ) {

            if ( filter.hasIcons ) {

                return {
                    ValueContainer,
                    Option: iconOption,
                };

            }
            else {

                return {
                    ValueContainer,
                };

            }

        }
        else {

            return {};

        }

    };

    function getSelectStyles() {

        const filterWidth = hasSingleFilter ? 202 : isSVP ? 163 : isMVP ? 175 : 202;
        const filterHeight = hasSingleFilter ? 50 : isSVP ? 40 : 50;

        return (
            {
                option: ( styles, state ) => {

                    return {
                        ...styles,
                        'color': '#001d4e',
                        'textDecoration': state.isFocused ? 'underline' : 'none',
                        'backgroundColor': state.isSelected ? state.theme.colors.primary : 'transparent',
                        'cursor': 'pointer',
                        'position': 'relative',
                        'padding': isSVP || isMVP ? '8px 22px 8px 12px' : '8px 12px',
                        '&:hover': {
                            backgroundColor: state.theme.colors.primary,
                        },
                        '&:after': {
                            content: '""',
                            width: '15px',
                            height: '15px',
                            display: isMulti && state.isSelected ? 'inline-block' : 'none',
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            margin: '0',
                            position: 'absolute',
                            right: '10px',
                            bottom: '30%',
                            backgroundImage: 'url(/assets/images/svg/icon-utility/x.svg)',
                        },
                    };

                },
                control: ( styles, state ) => {

                    return {
                        ...styles,
                        'backgroundColor': '#fff',
                        'borderWidth': '1px',
                        'borderStyle': 'solid',
                        'borderColor': '#929fb3',
                        'borderBottomColor': state.selectProps.menuIsOpen ? 'transparent' : '#929fb3',
                        'fontFamily': 'Graphik-Regular',
                        'fontSize': '16px',
                        'color': '#001d4e',
                        'width': filterWidth,
                        'height': filterHeight,
                        'marginRight': 10,
                        'borderBottomLeftRadius': state.selectProps.menuIsOpen ? 0 : 5,
                        'borderBottomRightRadius': state.selectProps.menuIsOpen ? 0 : 5,
                        '&:hover': {
                            borderColor: '#929fb3',
                            borderBottomColor: state.selectProps.menuIsOpen ? 'transparent' : '#929fb3',
                        },
                        '> div:first-of-type': {
                            padding: isSVP ? '2px 0 2px 4px' : '2px 8px',
                        },
                    };

                },
                menu: ( styles, state ) => {

                    return {
                        ...styles,
                        'backgroundColor': '#fff',
                        'border': '1px solid #929fb3',
                        'fontFamily': 'Graphik-Regular',
                        'fontSize': '12px',
                        'lineHeight': '19px',
                        'color': '#001d4e',
                        'width': filterWidth,
                        'margin': 0,
                        'maxHeight': customMaxHeight || '340px', // use custom value if provided
                        'overflowY': 'scroll',
                        'borderTopLeftRadius': state.selectProps.menuIsOpen ? 0 : 5,
                        'borderTopRightRadius': state.selectProps.menuIsOpen ? 0 : 5,
                        'borderTopColor': state.selectProps.menuIsOpen ? 'transparent' : '#929fb3',
                        ' > div': {
                            maxHeight: 'none',
                        },
                    };

                },
                indicatorSeparator: ( styles ) => {

                    return {
                        ...styles,
                        width: 0,
                    };

                },
                FilterIndicator: ( styles, state ) => {

                    return {
                        ...styles,
                        color: '#001d4e',
                        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    };

                },
                clearIndicator: ( styles ) => {

                    if ( isMulti ) {

                        return {
                            display: 'none',
                        };

                    }
                    else {

                        return {
                            ...styles,
                        };

                    }

                },
                dropdownIndicator: ( styles, state ) => {

                    return {
                        ...styles,
                        color: '#001156',
                        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    };

                },
                indicatorsContainer: ( styles ) => {

                    return {
                        ...styles,
                        padding: 0,
                    };

                },
                placeholder: ( styles ) => {

                    if ( isMulti ) {

                        return {
                            ...styles,
                            color: '#001156',
                            display: 'block',
                        };

                    }
                    else {

                        return {
                            ...styles,
                            color: '#001156',
                        };

                    }

                },

            }
        );

    }

    function getSelectTheme( theme ) {

        return ( {
            ...theme,
            borderRadius: 5,
            colors: {
                ...theme.colors,
                primary: '#ebf0f4',
                primary25: '#ebf0f4',
                neutral40: '#001d4e',
                neutral30: '#929fb3',
            },
        } );

    }

    function onChange( selectedOption, filterInfo ) {

        if ( isMulti ) {

            const selectedOptions = selectedOption.map( option => option.value );

            const multiFilterQuery = {
                filters: [
                    {
                        name: filterInfo.name,
                        isPivot: false,
                        facets: selectedOptions,
                        label: filter.label,
                        hasIcons: filter.hasIcons,
                    },
                ],
            };

            props.onChange( multiFilterQuery );

        }
        else {

            props.onChange( selectedOption, filterInfo );

        }

    }

    const customOption = customOptions();

    function handleOnBlur() {

        const e = null;

        throw e;

    }

    // to keep the select open for testing purposes add `menuIsOpen={ true }`

    return (
        <Select
            value={ value }
            onChange={ onChange }
            isSearchable={ false }
            options={ facetOptions }
            components={ customOption }
            aria-labelledby={ labelId }
            styles={ getSelectStyles() }
            name={ filter.name }
            hideSelectedOptions={ false }
            isMulti={ isMulti ? isMulti : false }
            id={ `filter-${ filter.name }` }
            theme={ getSelectTheme }
            onBlur={ handleOnBlur }
            placeholder={ props.placeholder ? props.placeholder : '' }
            captureMenuScroll={ false }
        />
    );

};

Filter.propTypes = {
    filter: shape( {
        name: string,
        label: string,
        hasIcons: bool,
        isPivot: bool,
        facets: arrayOf( oneOfType( [
            arrayOf( string ),
            shape( {
                name: string.isRequired,
                query: object,
            } ),
        ] ) ),
    } ).isRequired,
    labelId: string.isRequired,
    onChange: func,
    value: oneOfType( [
        arrayOf(
            shape( {
                name: string,
                query: object,
            } ),
        ),
        shape( {
            label: string,
            value: string,
        } ),
    ] ),
    isMulti: bool,
    placeholder: string,
    isMVP: bool,
    isSVP: bool,
    data: shape( {
        value: string,
        label: string,
    } ),
    isDisabled: bool,
    isSelected: bool,
    innerProps: object,
    hasSingleFilter: bool,
    customMaxHeight: string,
};

export default Filter;
